<ninety-button
  secondary
  stroked
  class="menu-btn meeting-action-btn full-width"
  [matMenuTriggerFor]="viewAnotherToolMenu"
  [disabled]="disabled()">
  <terra-icon size="16" icon="arrow-square-out" class="tool-icon" />
  View tools
</ninety-button>
<mat-menu #viewAnotherToolMenu="matMenu" xPosition="before" yPosition="above">
  @for (tool of tools(); track tool.label) {
    <ninety-button
      mat-menu-item
      [routerLink]="routerLinkFor(tool)"
      routerLinkActive="active"
      (click)="toolSelected.emit(tool.label)">
      <terra-icon size="20" [icon]="tool.icon" class="mat-menu-icon" />
      <span>{{ tool.label }}</span>
    </ninety-button>
  }
</mat-menu>
